import { initCypressStripeLoader } from './cypress-stripe-loader';

export function initStartupScripts() {
  initCypressStripeLoader();
}
